import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import Icon from '../icon/icon.component';
import { getInitialStyle } from './badge.style';

export class Badge extends Lightning.Component {
  static _template() {
    return _merge(
      {
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
        },
        Icon: {
          type: Icon,
        },
      },
      getInitialStyle(),
    );
  }

  _attach() {
    this.tag('Icon').on('txLoaded', () => {
      const icon = this.tag('Icon');
      this.patch({ w: icon.finalW, h: icon.finalH });
    });
  }

  _detach() {
    this.tag('Icon').removeAllListeners('txLoaded');
  }

  set iconData(value) {
    this.tag('Icon').iconData = value;
    this.alpha = value ? 1 : 0;
  }

  set iconColor(value) {
    this.tag('Icon').color = value;
  }

  get iconColor() {
    return this.tag('Icon').color;
  }
}
